// extracted by mini-css-extract-plugin
export var container = "_g7-0";
export var infoIcon = "_g7-2";
export var titleRowCol = "_g7-1";